import {
  IconNameEnum,
  useModuleBEM,
  useUiStyles,
} from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import clsx from "clsx";
import defaultStyles from "./ItineraryCardNotification.module.scss";
import { Icon } from "../Icon";

export enum NotificationSeverity {
  WARNING = "warning",
  ERROR = "error",
}

export type ItineraryCardNotificationProps = {
  severity: NotificationSeverity;
  label: string;
};

export const ItineraryCardNotification = ({
  severity,
  label,
}: ItineraryCardNotificationProps) => {
  const COMPONENT_KEY = CoreUiComponents.ItineraryCardNotification;
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const className = clsx(block, {
    [cn("error")]: severity === NotificationSeverity.ERROR,
    [cn("warning")]: severity === NotificationSeverity.WARNING,
  });

  const icon = <Icon iconName={IconNameEnum.warning} className={cn("icon")} />;

  return (
    <div className={className}>
      {icon} <span dangerouslySetInnerHTML={{ __html: label }} />
    </div>
  );
};

export default ItineraryCardNotification;
